import './App.css';
import Login from './Components/Pages/LoginView/LoginView';
import Routers from './Components/Routers/Routers';
import { AuthProvider, AuthContext } from './Context/AuthContext';
import { useContext } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function App() {
  const { isLogin } = useContext(AuthContext);

  const darkTheme = createTheme({
    palette: {
      mode: 'light',
    },

  });

  return (
    <div className="App">
      {(!isLogin) ? <Login /> : <ThemeProvider theme={darkTheme}> <Routers /> </ThemeProvider>}
    </div>
  );
}

export default function WrappedApp() {

  return (
    
    <AuthProvider>
      <App />
    </AuthProvider>

  );
}